var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIco1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 13.5,
    fill: "#BAEEB1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_705_4645)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9975 17.5799C25.6244 17.1096 26.0638 16.7809 26.4103 16.5672C26.7642 16.349 26.9307 16.3107 27.0195 16.3126C27.3008 16.3184 27.5647 16.4503 27.7381 16.6719C27.7929 16.7418 27.8622 16.898 27.8999 17.312C27.9369 17.7175 27.9375 18.2662 27.9375 19.0499V19.4999V23.9998V24.4498C27.9375 25.2335 27.9369 25.7822 27.8999 26.1877C27.8622 26.6017 27.7929 26.7579 27.7381 26.8278C27.5647 27.0494 27.3008 27.1813 27.0195 27.1871C26.9307 27.189 26.7642 27.1507 26.4103 26.9326C26.0638 26.7188 25.6244 26.3901 24.9975 25.9198L23.0625 24.4686V19.0311L24.9975 17.5799ZM29.0203 17.2098C29.062 17.667 29.0625 18.2585 29.0625 18.9936C30.3463 19.2542 31.3125 20.3892 31.3125 21.7498C31.3125 23.1106 30.3463 24.2455 29.0625 24.5061C29.0625 25.2412 29.062 25.8327 29.0203 26.2899C28.9783 26.7502 28.8881 27.184 28.6239 27.5214C28.2422 28.0088 27.6618 28.2991 27.0429 28.3119C26.6144 28.3208 26.2132 28.1327 25.8199 27.8901C25.4243 27.6463 24.9441 27.286 24.346 26.8375H24.346L24.3459 26.8374L24.3225 26.8198L22.3126 25.3125H20.8125V28.1251C20.8125 29.057 20.057 29.8126 19.125 29.8126C18.193 29.8126 17.4375 29.057 17.4375 28.1251V25.2683C15.7373 24.9986 14.4375 23.5261 14.4375 21.75C14.4375 19.7825 16.0325 18.1875 18 18.1875H22.3123L24.3225 16.6799L24.3459 16.6623C24.944 16.2137 25.4243 15.8535 25.8199 15.6096C26.2132 15.367 26.6144 15.1789 27.0429 15.1878C27.6618 15.2007 28.2422 15.4909 28.6239 15.9783C28.8881 16.3158 28.9783 16.7495 29.0203 17.2098Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_705_4645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(13.5 13.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco1);
export default __webpack_public_path__ + "static/media/ico_1.6797eb9ef065c56c5de2b447abaceabf.svg";
export { ForwardRef as ReactComponent };